import React, { useState } from "react";
import "./Navbar.css";
import { FaGithub, FaLinkedin, FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <h2 className="navbar-logo">Prateek Rai Srivastav</h2>
      </div>

      <ul className={`navbar-center ${menuOpen ? 'active' : ''}`}>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About Me</Link></li>
        {/* <li><Link to="/experience">Experience</Link></li> */}
        <li><Link to="/blogs">Blogs</Link></li>
        <li><Link to="/projects">Projects</Link></li>
        <li><Link to="/certifications">Certifications</Link></li>
        <li><Link to="/hackathons">Hackathons</Link></li>
      </ul>

      <div className="navbar-right">
        <a href="https://github.com/prateekrai1" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><FaGithub /></a>
        <a href="https://www.linkedin.com/in/prateek-rai-srivastav-50001821a" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
        <button className="hamburger" onClick={() => setMenuOpen(prev => !prev)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
